import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PushPinIcon from "@mui/icons-material/PushPin";
import ProfileAvatar from "../../ProfileAvatar";
import {FormatToLocalSystemDateTime} from "./../../../../utils/dateFormat";
import Attachment from "./Attachment";
import { useState } from "react";
import ContextMenu from "./ContextMenu";
import FlagIcon from "@mui/icons-material/Flag";
import "./ReceiverMessageCloud.css";

const ReceiverMessageCloud = ({
  message,
  messageId,
  createdByName,
  createdByOrganizationType,
  createdOn,
  hasAttachment,
  attachmentId,
  attachmentName,
  attachmentSize,
  isPinned,
  isFlagged,
  onContextMenuSet,
  contextOptions,
  style
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMessageClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleContextClick = (option) => {
    setAnchorEl(null);
    onContextMenuSet(option);
  };
  return (
    <>
      <Box px={3} mx={-3} className="d-flex w-100 py-3">
        <ProfileAvatar showUserIcon={false} senderName={createdByName} />
        <Box
          className="ps-3 py-1 w-100"
          style={{ maxWidth: "calc(100% - 55px)" }}
        >
          <Box>
            <Box className=" w-100 d-flex justify-content-between">
              <Typography
                variant="body1"
                className="text-truncate fw-semibold"
                sx={{
                  color: "var(--profile-title-clr)",
                  maxWidth: "calc(100% - 130px)",
                }}
              >
                {createdByName}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "var(--profile-recent-active-time-clr)" }}
              >
                {isPinned && (
                  <PushPinIcon
                    fontSize="1rem"
                    style={{ color: "var(--pin-icon-clr)" }}
                  />
                )}
                {isFlagged && (
                  <FlagIcon
                    fontSize="1rem"
                    style={{ color: "var(--flag-icon-clr)" }}
                  />
                )}
                {FormatToLocalSystemDateTime(createdOn)}
              </Typography>
            </Box>
            <Box className=" mb-2 w-100 d-flex align-items-center justify-content-between">
              <Typography
                variant="body2"
                className="text-truncate"
                sx={{
                  color: "var(--profile-catogory-n-quickview-clr)",
                  maxWidth: "calc(100% - 130px)",
                }}
              >
                {createdByOrganizationType}
              </Typography>
            </Box>
            <Box
              onContextMenu={handleMessageClick}
              id={`box-message-${messageId}`}
              aria-controls={open ? `message-${messageId}` : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
            >
              {hasAttachment ? (
                <Attachment
                  className={"attachment-received"}
                  attachmentSize={attachmentSize}
                  attachmentName={attachmentName}
                  message={message}
                  createdOn={createdOn}
                  attachmentId={attachmentId}
                />
              ) : (
                <Box className="msg-receive p-3 mb-3" {...style}>{message}</Box>
              )}
            </Box>
          </Box>
        </Box>
        {
          <ContextMenu
            createdByName={createdByName}
            messageId={messageId}
            anchorEl={anchorEl}
            open={open}
            hasAttachment={hasAttachment}
            isPinned={isPinned}
            isFlagged={isFlagged}
            handleContextClick={handleContextClick}
            contextOptions={contextOptions}
          />
        }
      </Box>
    </>
  );
};

export default ReceiverMessageCloud;
